import React from 'react'
import { SectionHeader } from 'src/components/framework/ui/section-header'
import { MarketRatioTable } from 'src/components/page/ratios/market-ratio-table'
import {
  MarketRatioRow,
  buildMarketRatioRows,
} from 'src/components/page/ratios/ratios'
import { useFeaturesContext } from 'src/contexts/features.context'
import { useSecurityContext } from 'src/contexts/security.context'
import { QualityRatioType } from 'src/shared/quality-ratio'

export const QualityRatio: React.FC = () => {
  const { features } = useFeaturesContext()
  const { security } = useSecurityContext()

  const dataSource = security.ratios.quality
  const featureFlags = features.ratios.quality

  const data = buildMarketRatioRows(QUALITY_DATA, featureFlags, dataSource)

  return (
    <>
      <SectionHeader>Quality</SectionHeader>
      <MarketRatioTable label={{ text: 'Name', visible: false }} rows={data} />
    </>
  )
}

const QUALITY_DATA: ReadonlyArray<MarketRatioRow<QualityRatioType>> = [
  {
    id: 'ROC',
    label: 'Return on Capital',
    ratioId: 'return-on-capital-employed-939',
    enabled: false,
  },
  {
    id: 'ROE',
    label: 'Return on Equity',
    ratioId: 'return-on-equity-817',
    enabled: false,
  },
  {
    id: 'operatingMargin',
    label: 'Operating Margin',
    ratioId: 'operating-profit-margin-638',
    enabled: false,
  },
]
